import { useQuery } from '@tanstack/react-query';
import { ItemsApi } from '@/common/api/items';
import { commonQueryKeys } from '@/common/queryKeys/common';

export const useItemAncestorsQuery = ({
  itemId,
  enabled = true,
}: {
  itemId: number;
  enabled?: boolean;
}) => {
  return useQuery({
    queryKey: commonQueryKeys.itemAncestors(itemId),
    queryFn: () => ItemsApi.getItemAncestors({ itemId }),
    enabled: !!itemId && enabled,
  });
};
